import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';

export interface FSMkDirAction extends WorkerAction {
  type: FSAction.MkDir;
  params: { path: string; skipSync?: boolean; disableRecursion?: boolean };
}

class FSMkDirActionError extends WorkerActionError {}

export async function FSMkDirActionFn({ fs, params, util }: WorkerFnParams<FSMkDirAction>): Promise<void> {
  const { path, skipSync, disableRecursion } = params;
  try {
    if (util.itemExistsAt(path)) {
      console.debug(`[WasmGit]: path "${path}" already exists.`);
      return;
    }

    if (!disableRecursion) {
      util.mkdirP(path);
    } else {
      fs.mkdir(path);
    }

    if (!skipSync) {
      await util.syncfs(false);
    }
  } catch (err) {
    throw new FSMkDirActionError(err);
  }
}
